import { render, staticRenderFns } from "./newAlterationForm.vue?vue&type=template&id=59adcd34&scoped=true&"
import script from "./newAlterationForm.vue?vue&type=script&lang=js&"
export * from "./newAlterationForm.vue?vue&type=script&lang=js&"
import style0 from "./newAlterationForm.vue?vue&type=style&index=0&id=59adcd34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59adcd34",
  null
  
)

export default component.exports